import { render, staticRenderFns } from "./MyArtists.vue?vue&type=template&id=52e61305&scoped=true"
import script from "./MyArtists.vue?vue&type=script&lang=js"
export * from "./MyArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e61305",
  null
  
)

export default component.exports